import {createContext, useContext} from "react";
import {AuthDataType} from "../store/auth";

// Crate context
const AuthContext = createContext<AuthDataType>(null);
const useAuthContext = () => useContext(AuthContext);

export default AuthContext;
export {useAuthContext};